// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"57":"index","589":"newsDetail","946":"news"}[chunkId] + "." + {"57":"6529c7d1","589":"7b0e1485","946":"722e9be3"}[chunkId] + ".css";
};